import React, { useEffect, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import color from "../../constants/color";

const DeliveryTimeline = (props) => {
  const [title, setTitle] = useState("");
  const [data, setData] = useState({});
  const { extra_data = {} } = props;

  useEffect(() => {
    setTitle(extra_data?.title);
    setData(extra_data?.data);
  }, []);

  return Array.isArray(data) && data.length ? (
    <View style={styles.container}>
      <Text style={styles.title}>{title}</Text>
      <View style={styles.markingsContainer}>
        {data.map((item, index) => (
          <View
            key={`${index}`}
            style={{
              flex: 1,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* First line */}
              <View
                style={{
                  //   width: 40,
                  flexBasis: 40,
                  flexGrow: 1,
                  height: 2,
                  backgroundColor:
                    item.color.toLowerCase() === "#ffffff"
                      ? "rgba(0, 0, 0, 0.2)"
                      : item.color,
                  opacity: index === 0 ? 0 : 1,
                }}
              />
              {/* Dot  */}
              <View
                style={{
                  backgroundColor:
                    item.color.toLowerCase() === "#ffffff"
                      ? "rgba(0, 0, 0, 0.2)"
                      : item.color,
                  height: 14,
                  width: 14,
                  borderRadius: 100,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    height: 8,
                    backgroundColor: "white",
                    width: 8,
                    borderRadius: 100,
                    opacity: item.color.toLowerCase() === "#ffffff" ? 1 : 0,
                  }}
                />
              </View>
              {/* Second line */}
              <View
                style={{
                  flexBasis: 40,
                  flexGrow: 1,
                  height: 2,
                  backgroundColor:
                    item.color.toLowerCase() === "#ffffff"
                      ? "rgba(0, 0, 0, 0.2)"
                      : item.color,
                  opacity: index === data.length - 1 ? 0 : 1,
                }}
              />
            </View>
            <View>
              <Text
                numberOfLines={1}
                style={{
                  textAlign: "center",
                  fontSize: 12,
                  lineHeight: 16,
                  color: color.lightBlack,
                  marginTop: 6,
                }}
              >
                {item.text}
              </Text>

              <Text
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: 10,
                  lineHeight: 16,
                  marginTop: 2,
                }}
              >
                {item.sub_text === "null" ? "" : item.sub_text}
              </Text>
            </View>
          </View>
        ))}
      </View>
    </View>
  ) : (
    <></>
  );
};

const styles = StyleSheet.create({
  title: {
    fontWeight: "bold",
    fontSize: 14,
    lineHeight: 22,
    marginBottom: 10,
  },
  container: {
    elevation: 1,
    paddingHorizontal: 15,
    paddingTop: 15,
    paddingBottom: 20,
    backgroundColor: "white",
    borderRadius: 10,
    marginHorizontal: 15,
    marginVertical: 5,
  },
  markingsContainer: {
    flexDirection: "row",
    justifyContent: "center",
  },
});

export default DeliveryTimeline;
